import api from '@/services/api';
import SearchQuery from '@/utils/SearchQuery';
import { PageDTO } from '@/dtos/generics';
import AttachmentsDTO from '@/dtos/attachments/AttachmentsDTO';
import CreateAttachmentsDTO from '@/dtos/attachments/CreateAttachmentsDTO';

const attachmentsProvider = {
  async list(
    filters: SearchQuery
  ): Promise<PageDTO<AttachmentsDTO>> {
    try {
      const { data } = await api.get<PageDTO<AttachmentsDTO>>(`/attachments`, {
        params: { 
          search: filters.search,
          page: filters.page,
          perPage: filters.size,
         },
      });
      return data;
    } catch (error) {
      console.error('Erro ao buscar attachments:', error);
      throw error;
    }
  },

  async create(attachments: CreateAttachmentsDTO): Promise<AttachmentsDTO> {
    const formData = new FormData();
    formData.append('codeValue', attachments.codeValue);
    formData.append('resourceId', attachments.resource_id);
    formData.append('latitude', attachments.latitude.toString());
    formData.append('longitude', attachments.longitude.toString());
    formData.append('company_id', attachments.company_id);
    formData.append('user_id', attachments.user_id);
    attachments.files.forEach(file => {
      formData.append('file', file);
    });

    try {
      const { data } = await api.post<AttachmentsDTO>('/attachments', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return data;
    } catch (error) {
      console.error('Erro ao criar attachments:', error);
      throw error;
    }
  },

  async findById(id: string): Promise<AttachmentsDTO> {
    try {
      const { data } = await api.get<AttachmentsDTO>(`/attachments/${id}`);
      return data;
    } catch (error) {
      console.error('Erro ao procurar attachments:', error);
      throw error;
    }
  },

  async findByCode(codeValue: string): Promise<AttachmentsDTO[]> {
    try {
      const { data } = await api.get<AttachmentsDTO[]>(
        `/attachments/code/${codeValue}`
      );
      return data;
    } catch (error) {
        console.error('Erro ao procurar attachments:', error);
        throw error;
    }
  },

  async findByIdCompany(id: string): Promise<AttachmentsDTO[]> {
    try {
      const { data } = await api.get<AttachmentsDTO[]>(
        `/attachments/company/${id}`
      );
      return data;
    } catch (error) {
        console.error('Erro ao procurar attachments:', error);
        throw error;
    }
  },

  async delete(id: string): Promise<void> {
    try {
      await api.delete(`/attachments/${id}`);
    } catch (error) {
      console.error('Erro ao deletar attachments:', error);
      throw error;
    }
  },

  async download(id: string, filename: string): Promise<void> {
    try {
      const response = await api.get(`/attachments/download/${id}`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      window.location.reload();
    } catch (error) {
      console.error('Erro ao baixar attachments:', error);
      throw error;
    }
  },
};

export default attachmentsProvider;
